import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, RouterOutlet } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

import { LanguageService } from '@services/language/1.0/language.service';

@Component({
  selector: 'txp-language-component',
  templateUrl: './language.component.html',
  styleUrls: ['./language.component.scss'],
  standalone: true,
  imports: [RouterOutlet],
})
export class LanguageComponent implements OnInit {
  defaultLanguageCode: string;

  constructor(
    private translate: TranslateService,
    private route: ActivatedRoute,
    private languageService: LanguageService,
  ) {}

  ngOnInit() {
    this.defaultLanguageCode = this.languageService.defaultLanguage?.code;

    this.route.params.subscribe((params) => {
      this.translate.use(params.lang || this.defaultLanguageCode);
    });
  }
}
